<div class="space-1">
  <page-load-header *ngIf="!initialized"></page-load-header>

  <div class="row mb-3">
    <div class="col-md-6">
      <div class="dropdown"><h4>Conferences</h4>
      </div>
    </div>
    <div class="col-md-6 text-right"></div>
  </div>

  <div *ngIf="initialized">
    <div *ngIf="!conferences || conferences.length ==0" class="row no-gutters no-candidates" style="min-height: 200px">
      <div class="col-sm-12 my-auto">
        <h1><i class="fas fa-empty-set"></i></h1>
        <h4>No Conferences</h4>
        <p>You have not attended any conferences with CEUs.</p>
      </div>
    </div>
    <ng-container *ngFor="let conference of conferences; let idx=index ">
      <div *ngIf="idx%5 == 0 " class="mt-1 mb-2">
        <ad-display [isMargin]="false"></ad-display>
      </div>
      <div class="card mb-2">
        <div class="card-body p-4">
          <div class="media d-block d-sm-flex">
            <div class="media-body">
              <div class="media mb-2">
                <div class="media-body">
                  <div class="row">
                    <div class="col-md-10">
                      <h1 class="h5 mb-1">
                        <a [routerLink]="[conference.id, 'event-summaries']">{{ conference.name }}</a>
                      </h1>

                      <div class="d-md-flex align-items-md-center">
                        <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
                          <h2 class="small text-secondary mb-0">Date</h2>
                          <small class="fas fa-calendar-alt text-secondary align-middle mr-1"></small>
                          <span *ngIf="(conference.startDate | date: 'shortDate') != (conference.endDate | date: 'shortDate')" class="align-middle">{{ conference.startDate | date: 'shortDate' }} - {{ conference.endDate | date: 'shortDate' }}</span>
                          <span *ngIf="(conference.startDate | date: 'shortDate') == (conference.endDate | date: 'shortDate')" class="align-middle">{{ conference.startDate | date: 'shortDate' }} </span>
                        </div>
                        <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
                          <h2 class="small text-secondary mb-0">Status</h2>
                          <span *ngIf="conference.ceuCertificateReleased" class="align-middle text text-success"><strong>Ready</strong></span>
                          <span *ngIf="!conference.ceuCertificateReleased" class="align-middle text-warning"><strong>Processing</strong></span>
                        </div>
                        <div *ngIf="conference.city && conference.state" class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
                          <h4 class="small text-secondary mb-0">Location</h4>
                          <span class="align-middle">{{ conference.city + ', ' + conference.state }}</span>
                        </div>
                        <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
                          <h2 class="small text-secondary mb-0">Available Types</h2>
                          <span class="align-middle text-center">{{ conference.ceuTypes.join(', ') }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="text-right">
                        <div class="position-relative d-inline-block text-right">
                          <div class="dropdown">
                            <button class="btn btn-xs btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</button>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                              <a class="dropdown-item" [routerLink]="[conference.id, 'event-summaries']">Review Events & Resolve Problems</a>
                              <a *ngIf="!conference.ceuCertificateReleased" class="dropdown-item" href="javascript:void(0)" (click)="viewCertificates()">View Certificates</a>
                              <a *ngIf="conference.ceuCertificateReleased" class="dropdown-item" [routerLink]="['.', conference.id, 'certificates']">View Certificates</a>

                              <!-- <div class="dropdown-divider"></div> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
